var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.335 13.1v2.5a1.666 1.666 0 0 1-1.817 1.667 16.492 16.492 0 0 1-7.191-2.559 16.25 16.25 0 0 1-5-5A16.492 16.492 0 0 1 .768 2.483 1.667 1.667 0 0 1 2.427.667h2.5A1.667 1.667 0 0 1 6.593 2.1c.106.8.302 1.586.584 2.342A1.667 1.667 0 0 1 6.802 6.2L5.743 7.258a13.333 13.333 0 0 0 5 5l1.059-1.058a1.667 1.667 0 0 1 1.758-.375c.756.282 1.542.478 2.342.583a1.667 1.667 0 0 1 1.433 1.692Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPhone;